// cookie的公共函数
const getCookie = function (name) {
  const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  const arr = document.cookie.match(reg)
  if (arr && arr.length) { return unescape(arr[2]) } else { return null }
}

// const setCookie = function (name, value, day = 30) {
//   const exp = new Date()
//   exp.setTime(exp.getTime() + day * 24 * 60 * 60 * 1000)
//   document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
// }

export const setCookie = (name, value, days) => {
  let valueStr = ''
  if(typeof value == 'string'){
    valueStr = value
  }else{
    valueStr = JSON.stringify(value);
  }

  if (valueStr) {
    const domain = '.' + document.domain.split('.').reverse().slice(0,2).reverse().join('.')
    let cookie = `${name}=${escape(valueStr)}`;
    if(days){
      const exp = new Date();
      exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
      cookie +=`;expires=${exp.toUTCString()}`
    }
    cookie += `;domain=${domain}`
    document.cookie = cookie
  }
};

const removeCookie = function (name) {
  const exp = new Date()
  exp.setTime(exp.getTime() - 1)
  const cval = getCookie(name)
  if (cval != null) { document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() }
}

export default {
  getCookie, setCookie, removeCookie
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js